import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './shared/services/error.service';
import { LoggingService } from './shared/services/logging.service';
import { NotificationService } from './shared/services/notification.service';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private injector: Injector) { }
  
  handleError(error: Error | HttpErrorResponse) {
    const errorService = this.injector.get(ErrorService);
    const logger = this.injector.get(LoggingService);
    const notifier = this.injector.get(NotificationService);

    let message = "";
    let stackTrace = "";

    // Il fallimento della chiamata che scrive i log non va notificato ne' registrato:
    // registrarlo produrrebbe una nuova chiamata allo stesso endpoint, quindi un nuovo
    // errore, in una catena che si autoalimenta. In AppLog restano tre "504 Gateway
    // Timeout" su /api/applogs nati cosi', fra il 25/02 e il 20/03/2026.
    if (error instanceof HttpErrorResponse && (error.url ?? '').toLowerCase().includes('/api/applogs')) {
      console.error(error);
      return;
    }

    if (error instanceof HttpErrorResponse) {
      // Server error
      message = errorService.getServerErrorMessage(error);
      //stackTrace = errorService.getServerErrorStackTrace(error);
      notifier.showError(message);
    } else {
      // Client Error
      message = errorService.getClientErrorMessage(error);
      stackTrace = errorService.getClientStack(error);

      notifier.showError(message);
    }
    // Always log errors
    logger.logError(message, stackTrace);
    console.error(error);
  }
}
